export const getTheme = store => store.themes
export const getThemeTemplate = store => 'nm'
export const getActiveThemeSelector = store => store.themes.theme
